import BqnContext from "common/BqnContext";
import React, { useContext } from "react";

const doesNothing = () => {};

const DeleteRangeButton = ({ onClick = doesNothing }) => (
  <a className="waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const RangeItem = ({
  id,
  range = "",
  bqn,
  from = undefined,
  deleted,
  even = false,
  onDelete = doesNothing,
  hasBqnColumn = false,
  fromRaw = undefined,
}) => {
  if (deleted === true) {
    return null;
  }
  const doRangeDelete = () => {
    onDelete(id);
  };

  return (
    <tr className={`${even ? "even" : "odd"}`}>
      {hasBqnColumn && <td> {bqn} </td>}
      <td>
        {range}
        {"  "}
        {from || fromRaw ? (
          <span className="col-red">
            {fromRaw ? fromRaw : `Suggested to allow traffic from ${from}`}
          </span>
        ) : null}
      </td>
      <td className="text-center hides-content-to-operators">
        <DeleteRangeButton onClick={doRangeDelete} />
      </td>
    </tr>
  );
};
const RangesList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) =>{
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  const hasBqnColumn = mode === "cluster";


  return items.length === 0 ? (
    <h5>No firewall rules configured: all IP addresses allowed.</h5>
  ) : (
    <table className="table table-striped">
      <thead>
        <tr>
          {hasBqnColumn &&<th>BQN</th>}
          <th>ALLOWED IP RANGES</th>
          <th className="text-center">ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        {items
          .filter(({ deleted, bqn }) => deleted !== true && (!hasBqnColumn || bqnId === "all" || parseFloat(bqnId) === parseFloat(bqn)))
          .map(({ __id, ...client }, index) => (
            <RangeItem
              id={__id}
              key={__id}
              {...client}
              even={(index + 1) % 2 === 0}
              onDelete={() => onDelete(__id)}
              onEdit={() => onEdit(__id)}
              hasBqnColumn={hasBqnColumn}
            />
          ))}
      </tbody>
    </table>
  );
}
export default RangesList;
